import React from 'react';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import SaveButton from './SaveButton';


const SettingsTab = (props) => {
    const {
        couple,
        setCouple,
        handleChange,
        state
    } = props;

    const referredOptions = ['Bridal Show','Bridal Solutions','Durham Wedding Show','EventSource','Facebook','Family/Friend','Online search (Google, Yahoo, Bing)','Trade Sensations','Vendor','Venue','Vineyard Bride','Wedding Wire'];
    const statuses = ['Lead', 'Follow-Up', 'Pending', 'Booked', 'Complete', 'Cancelled'];

    const referredValue = referredOptions.indexOf(state.couple_referred) >= 0 ? state.couple_referred : '';
    const referralType = ['Vendor','Venue','Bridal Show','Family/Friend'].indexOf(referredValue) >= 0 ? referredValue : false;

    const [formErrors, setFormErrors] = React.useState({});

    const isAdmin = window.isAdmin;

    return (
        <form>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <TextField
                        select
                        fullWidth
                        margin="normal"
                        onChange={handleChange('couple_referred')}
                        label="Referred"
                        value={referredValue || ''}
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        {referredOptions.map((option, k) => (
                            <MenuItem key={k} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                    {referralType && (
                        <TextField
                            fullWidth
                            margin="normal"
                            onChange={handleChange('referral_vendor_venue')}
                            label={`Name of ${referralType}`}
                            value={state.referral_vendor_venue || ''}
                        />
                    )}
                    <TextField
                        select
                        fullWidth
                        margin="normal"
                        onChange={handleChange('couple_type')}
                        label="Stage"
                        value={state.couple_type}
                        disabled={!isAdmin}
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        {statuses.map((option, k) => (
                            <MenuItem key={k} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('inquiry_url')}
                        label="Inquiry URL"
                        value={state.inquiry_url || ''}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        select
                        fullWidth
                        margin="normal"
                        onChange={handleChange('email_list')}
                        label="Subscribe to Email/Vlog"
                        value={state.email_list || 0}
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        <MenuItem value={0}>
                            No
                        </MenuItem>
                        <MenuItem value={1}>
                            Yes
                        </MenuItem>
                    </TextField>
                    <TextField
                        select
                        fullWidth
                        margin="normal"
                        onChange={handleChange('is_active')}
                        label="Activity"
                        value={state.is_active || false}
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        <MenuItem value={true}>
                            Active
                        </MenuItem>
                        <MenuItem value={false}>
                            Inactive
                        </MenuItem>
                    </TextField>
                </Grid>
            </Grid>
            <Box mt={4} mb={3}>
                <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                >
                    <Grid item xs={12} sm={4}>
                        <SaveButton
                            state={state}
                            coupleId={couple.id}
                            setCouple={setCouple}
                            setFormErrors={setFormErrors}
                        />
                    </Grid>
                </Grid>
            </Box>
        </form>
    );
};

export default SettingsTab;
